/**
 * @generated SignedSource<<169ac9400e08f93593a6efa5a52f11f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddScreenInfoDismissMutation$variables = {
  screenId: string;
};
export type AddScreenInfoDismissMutation$data = {
  readonly storecast: {
    readonly dismissInfo: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type AddScreenInfoDismissMutation = {
  response: AddScreenInfoDismissMutation$data;
  variables: AddScreenInfoDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "dismissInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenInfoDismissMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddScreenInfoDismissMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc0b81f2de41dd3001e43d274aa20b57",
    "id": null,
    "metadata": {},
    "name": "AddScreenInfoDismissMutation",
    "operationKind": "mutation",
    "text": "mutation AddScreenInfoDismissMutation(\n  $screenId: ID!\n) {\n  storecast {\n    dismissInfo(screenId: $screenId) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99acee449de630ff52e5ff3bff458d1f";

export default node;
